<template>
  <section role="main" class="content-body">
    <header class="page-header">
      <h2>學年度預算</h2>
      <div class="right-wrapper">
        <ol class="breadcrumbs">
          <li>
            <a href="/">
              <i class="fa fa-home"></i>
            </a>
          </li>
          <li><span>助學金管理系統</span></li>
          <li><span>預算分配</span></li>
          <li><span>學年度預算</span></li>
        </ol>
      </div>
    </header>
    <div id="tabs-01" class="row">
      <div id="tabs-03" class="row">
        <div class="col-md-12">
          <section class="panel">
            <header class="panel-heading">
              <div class="panel-actions">
                <a href="#" class="panel-action panel-action-toggle" data-panel-toggle></a>
              </div>
              <h2 class="panel-title">查詢條件</h2>
            </header>
            <div class="panel-body" align="left">
              <div>學年度/單位查詢:
                <select v-model="search.schYear">
                  <option :value="null">請選擇</option>
                  <option v-for="item in schYearList" :key="item" :value="item">{{item}}</option>
                </select>　
                <select v-if="pageAdmin" v-model="search.deptCode">
                  <option :value="null">請選擇</option>
                  <option v-for="(item, index) in unitList" :key="index" :value="item.code">{{item.value}}</option>
                </select>　
                <a href="#" @click.prevent="searchSubmit" class="btn-upload btn btn-primary" style="background-color:#337AB7; border-color:#2E6DA4;">查詢</a>
                <a href="#" @click.prevent="searchClear" class="btn-upload btn btn-primary" style="background-color:#666; border-color:#666;">清空</a>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
    <!-- start: page -->
    <div id="tabs-01" class="row">
      <div id="tabs-03" class="row">
        <div class="col-md-12">
          <section class="panel">
            <div class="panel-body" align="right">
              <table ref="table" class="table table-no-more table-bordered table-striped mb-none">
                <thead>
                  <tr>
                    <th class="text-center" width="5%">序號</th>
                    <th class="text-center" width="10%">學年度</th>
                    <th class="text-center" width="20%">單位/系所名稱</th>
                    <th class="text-center" width="10%">類型</th>
                    <th class="text-center" width="10%">總預算</th>
                    <th class="text-center" width="10%">已擴增預算</th>
                    <th class="text-center" width="10%">預算支用情形</th>
                    <!-- <th class="text-center" width="10%">剩餘預算</th> -->
                    <th v-show="pageAdmin" class="text-center" width="15%">擴增預算/紀錄</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in list" :key="index">
                    <td data-title="序號" class="text-center">{{index + 1}}</td>
                    <td data-title="學年度" class="text-center">{{item.schYear}}</td>
                    <td data-title="單位/系所名稱" class="text-center">{{item.deptName}}</td>
                    <td data-title="類型" class="text-center">{{item.workstudyType}}</td>
                    <td data-title="總預算" class="text-center">
                      <router-link v-if="item.workstudyType == '生活'" :to="'/budget/total-study/' + item.budgetId">{{item.totalBudget | numberWithCommas}}</router-link>
                      <router-link v-else :to="'/budget/total-work/' + item.budgetId">{{item.totalBudget | numberWithCommas}}</router-link>
                    </td>
                    <td data-title="已擴增預算" class="text-center">{{item.budgetExpansion | numberWithCommas}}</td>
                    <td data-title="已用預算" class="text-center">
                      <router-link v-if="item.workstudyType == '生活'" :to="'/budget/used-study/' + item.budgetId">{{item.usedBudget | numberWithCommas}}</router-link>
                      <router-link v-else :to="'/budget/used-work/' + item.budgetId">{{item.usedBudget | numberWithCommas}}</router-link>
                    </td>
                    <!-- <td data-title="剩餘預算" class="text-center">{{item.remainingBudget | numberWithCommas}}</td> -->
                    <td v-show="pageAdmin" data-title="擴增預算/紀錄" class="text-center"><router-link :to="'/budget/increase/' + item.budgetId + '/' + (item.workstudyType == '生活' ? '1' : '2')" class="btn-upload btn s_btn_o">擴增預算</router-link></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import '../../mixins/pageAdmin'
export default {
  data() {
    return {
      search: {
        schYear: null,
        deptCode: null
      },
      list: [],
      schYearList: [],
      unitList: [],
    };
  },
  async mounted() {
    this.$http.get("/api/budget/import-file-yearlist").then(a => {
      this.schYearList = a.body;
    });
    this.$http.get("/api/shared/unit-list").then(a => {
      this.unitList = a.body;
    });
    this.load();
  },
  methods: {
    load() {
      if ($.fn.DataTable.isDataTable(this.$refs.table)) {
        $(this.$refs.table).DataTable().destroy();
      }
      this.$http
        .get("/api/budget", { params: { schYear: this.search.schYear, deptCode: this.search.deptCode } })
        .then(a => {
          this.list = a.body;
          this.$nextTick(b => {
            $(this.$refs.table).DataTable({
              bFilter: false,
              bLengthChange: false,
              language: {
                info: "第 _PAGE_ 頁 / 總共 _PAGES_ 頁"
              },
              columnDefs: [
                {
                  targets: 0,
                  orderable: false,
                },
              ],
              order: [1, "desc"],
              columns: [
                { width: "6%" },
                { width: "9%" },
                { width: "20%" },
                { width: "10%" },
                { width: "10%" },
                { width: "10%" },
                { width: "10%" },
                // { width: "10%" },
                { width: "15%" }
              ]
            });
          });
        });
    },
    searchSubmit() {
      this.load();
    },
    searchClear() {
      this.search.schYear = null;
      this.search.deptCode = null;
    }
  }
};
</script>

<style>
</style>